/* eslint-disable */
import {
  Grid,
  Stack,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  IconButton,
  Button
} from '@material-ui/core';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AddIcon from '@mui/icons-material/Add';
import PropTypes from 'prop-types';
import React from 'react';

EnvironmentVariableSettings.propTypes = {
  vm: PropTypes.object,
  updateVm: PropTypes.func
};

export function validateEnvVariables(env) {
  const errors = {};
  const names = env?.map((e) => e.name.trim()) ?? [];

  env?.forEach((envVar, index) => {
    if (!envVar.name.trim())
      errors[index] = { ...errors[index], name: 'Environment variable name is required' };
    if (!envVar.value.trim())
      errors[index] = { ...errors[index], value: 'Environment variable value is required' };
    if (envVar.name.trim() && names.indexOf(envVar.name.trim()) !== index) {
      errors[index] = {
        ...errors[index],
        name: 'Duplicated environment variable name, please use a different name'
      };
    }
  });

  return errors;
}

export function EnvironmentVariableSettings({ vm, updateVm }) {
  const handleRemoveEnvVariable = (envIndex) => {
    const newObject = { ...vm };
    newObject.env = newObject.env.filter((_, index) => index !== envIndex);
    updateVm(newObject);
  };

  const handleAddEnvVariable = () => {
    const newObject = { ...vm };
    newObject.env = [...(newObject.env || []), { name: '', value: '' }];
    updateVm(newObject);
  };

  const handleEnvChange = (field, value, envIndex) => {
    const newObject = { ...vm };
    newObject.env[envIndex][field] = value;
    updateVm(newObject);
  };

  const envErrors = validateEnvVariables(vm.env);

  return (
    <Grid item xs={12}>
      <Accordion>
        <AccordionSummary sx={{ paddingLeft: 0 }} expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Environment Variable Settings</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Stack direction="column" spacing={2} data-testid="vm-env-settings">
            {vm.env?.map((envVar, index) => (
              <Grid container item xs={12} key={index}>
                <Grid item xs={4} pr={2}>
                  <TextField
                    label="Name"
                    value={envVar.name}
                    size="small"
                    error={!!envErrors[index]?.name}
                    helperText={envErrors[index]?.name}
                    onChange={(e) => handleEnvChange('name', e.target.value, index)}
                    onBlur={(e) => handleEnvChange('name', e.target.value.trim(), index)}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    label="Value"
                    value={envVar.value}
                    size="small"
                    error={!!envErrors[index]?.value}
                    helperText={envErrors[index]?.value}
                    onChange={(e) => handleEnvChange('value', e.target.value, index)}
                    onBlur={(e) => handleEnvChange('value', e.target.value.trim(), index)}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={1}>
                  <IconButton
                    data-testid="remove-env-variable-btn"
                    color="error"
                    onClick={() => handleRemoveEnvVariable(index)}
                  >
                    <DeleteOutlineOutlinedIcon />
                  </IconButton>
                </Grid>
              </Grid>
            ))}
            <Button
              data-testid="add-env-variable-btn"
              startIcon={<AddIcon />}
              variant="contained"
              sx={{ maxWidth: 220 }}
              onClick={() => handleAddEnvVariable()}
            >
              Add Env Variable
            </Button>
          </Stack>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
